<div class="text-center mb-5">
    <a [routerLink]="['/']">
        <span class="logo-lg">
          @if(mode === LAYOUT_MODE.LIGHTMODE) {
            <img src="assets/images/logo-light.svg" alt="" height="32">
          } @else {
            <img src="assets/images/logo-dark.svg" alt="" height="32">
          }
        </span>
    </a>
</div>
